import { SITE_HG, COUNTRY } from '@/config';

const N8N_URL_BY_BRAND = {
  ar: `${SITE_HG}/vps-hosting/hosting-n8n`,
  bo: `${SITE_HG}/vps-hosting/hosting-n8n`,
  br: `${SITE_HG}/servidor-vps/hospedagem-n8n`,
  cl: `${SITE_HG}/vps-hosting/hosting-n8n`,
  co: `${SITE_HG}/vps-hosting/hosting-n8n`,
  cr: `${SITE_HG}/vps-hosting/hosting-n8n`,
  do: `${SITE_HG}/vps-hosting/hosting-n8n`,
  ec: `${SITE_HG}/vps-hosting/hosting-n8n`,
  mx: `${SITE_HG}/vps-hosting/hosting-n8n`,
  pa: `${SITE_HG}/vps-hosting/hosting-n8n`,
  py: `${SITE_HG}/vps-hosting/hosting-n8n`,
  pe: `${SITE_HG}/vps-hosting/hosting-n8n`,
  sv: `${SITE_HG}/vps-hosting/hosting-n8n`,
  uy: `${SITE_HG}/vps-hosting/hosting-n8n`,
};

export const N8N_URL = N8N_URL_BY_BRAND[COUNTRY] || N8N_URL_BY_BRAND.br;
